export default function Style(){
  return(
    <style>
      {
        `
       #heroTwo {
  width: 100%;
  height: 88vh;
 background : linear-gradient(to bottom, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0.25) 100%);
  padding: 0;
}

#heroTwo:before {
  content: "";
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  z-index: -1;
}

#heroTwo .container {
  z-index: 2;
  padding: 0 11% 0 11%;
}

#heroTwo h1 {
  margin: 17px 45px 15px 45px;
  font-size: 64px;
  font-weight: 400;
  line-height: 77px;
  color: #fff;
}

.fs-fjalla {
  font-family: 'Fjalla One';
}

#heroTwo h1 span {
  border-bottom: 4px solid #3498db;
}



#heroTwo .btn-get-started {
  font-family: 'Josefin Sans';
  font-weight: 600;
  font-size: 18px;
  display: inline-block;
  padding: 16px 32px !important;
  margin-top: 32px;
  border-radius: 0px;
  transition: ease-in-out 0.3s;
  text-decoration: none !important;
  color: #010101;
  background: #fcbd00;
}

#heroTwo .btn-get-started:hover {
  background: #ffdeb1;
}




@media (min-width: 768px) {
  #heroTwo h1 {
    font-size: 48px;
    line-height: 58px;
  }

}

@media (max-width: 768px) {
  #heroTwo h1 {
    font-size: 40px;
    line-height: 48px;
    font-weight: 400;
  }
}

/* // @media (max-width: 992px) {
//   #heroTwo {
//     height: calc(100vh - 70px);
//   }
// } */

@media (min-width: 1280px) {
  #heroTwo h1 {
    font-size: 62px;
    line-height: 74px;
  }

}

@media (min-width: 1530px) {

  .fs-16-18 {
    font-size: 18px !important;
  }
}

@media (max-width: 1530px) {
  .fs-16-18 {
    font-size: 16px !important;
  }


  @media (min-width: 1534px) {
    #heroTwo h1 {
      font-size: 64px;
      line-height: 77px;
    }

  }
}

.video-wrapper {
  position: relative;
  height: 88vh;
}

.video-wrapper video {
 
  position: absolute;
  width: 100%;
  object-fit: cover;
  z-index: 0;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  right: 0;
  z-index: 0;
} 
        `
      }
    </style>
  )
}
